import { useSelector } from "react-redux";

import { selectAll, selectAllCatalog } from "./selectors";

export const useQuickActions = () => {
  return useSelector(selectAll);
};

export const useQuickActionsCatalog = () => {
  return useSelector(selectAllCatalog);
};
